(function(){
  var panel,input,body,foot,timer,lastQ='',sel=-1;

  function build(){
    if(document.getElementById('rxSearch'))return;
    var w=document.createElement('div');
    w.className='rx-search';w.id='rxSearch';
    w.innerHTML='<div class="rx-search__bg" data-rx-close></div>'+
      '<div class="rx-search__panel">'+
      '<form class="rx-search__bar" action="/search" method="get" role="search">'+
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>'+
      '<input type="search" name="q" autocomplete="off" placeholder="Caută produse…" aria-label="Caută produse">'+
      '<button type="button" class="rx-search__x" data-rx-close aria-label="Închide"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>'+
      '</form>'+
      '<div class="rx-search__body"><p class="rx-search__hint">Scrie ce cauți — rezultatele apar pe măsură ce tastezi.</p></div>'+
      '<div class="rx-search__foot" hidden></div>'+
      '</div>';
    document.body.appendChild(w);
    panel=w;input=w.querySelector('input');body=w.querySelector('.rx-search__body');foot=w.querySelector('.rx-search__foot');
    w.querySelectorAll('[data-rx-close]').forEach(function(b){b.addEventListener('click',close)});
    input.addEventListener('input',onType);
    input.addEventListener('keydown',onKey);
    w.querySelector('form').addEventListener('submit',function(e){
      if(!input.value.trim())e.preventDefault();
    });
  }

  function open(e){
    if(e)e.preventDefault();
    build();
    panel.classList.add('is-on');
    document.body.style.overflow='hidden';
    setTimeout(function(){input.focus()},60);
  }
  function close(){
    if(!panel)return;
    panel.classList.remove('is-on');
    document.body.style.overflow='';
  }

  function money(c){try{return (c/100).toLocaleString('ro-RO',{minimumFractionDigits:2,maximumFractionDigits:2})+' lei'}catch(e){return (c/100).toFixed(2)+' lei'}}

  function onType(){
    var q=input.value.trim();
    clearTimeout(timer);
    if(q.length<2){
      body.innerHTML='<p class="rx-search__hint">Scrie ce cauți — rezultatele apar pe măsură ce tastezi.</p>';
      foot.hidden=true;lastQ='';return;
    }
    timer=setTimeout(function(){run(q)},240);
  }

  function run(q){
    if(q===lastQ)return;lastQ=q;sel=-1;
    body.innerHTML='<span class="rx-search__spin"></span>';
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=8',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json()})
      .then(function(d){
        var items=(d.resources&&d.resources.results&&d.resources.results.products)||[];
        if(!items.length){
          body.innerHTML='<p class="rx-search__empty">Niciun produs pentru „'+q.replace(/[<>&]/g,'')+'”.</p>';
          foot.hidden=true;return;
        }
        var html='<ul class="rx-search__list">';
        items.forEach(function(p){
          var img=p.featured_image&&p.featured_image.url?'<img src="'+p.featured_image.url+'&width=140" alt="" loading="lazy">':'';
          var price=p.price?money(parseInt(p.price,10)):'';
          var old=(p.compare_at_price&&parseInt(p.compare_at_price,10)>parseInt(p.price,10))?'<del>'+money(parseInt(p.compare_at_price,10))+'</del>':'';
          html+='<li class="rx-search__item"><a href="'+p.url+'">'+
            '<span class="rx-search__thumb">'+img+'</span>'+
            '<span class="rx-search__txt"><span class="rx-search__t">'+p.title+'</span>'+
            (price?'<span class="rx-search__p">'+old+price+'</span>':'')+'</span></a></li>';
        });
        html+='</ul>';
        body.innerHTML=html;
        foot.hidden=false;
        foot.innerHTML='<a href="/search?q='+encodeURIComponent(q)+'">Vezi toate rezultatele</a>';
      })
      .catch(function(){
        body.innerHTML='<p class="rx-search__empty">Eroare la căutare. Încearcă din nou.</p>';
      });
  }

  function onKey(e){
    var items=body.querySelectorAll('.rx-search__item');
    if(e.key==='Escape'){close();return}
    if(!items.length)return;
    if(e.key==='ArrowDown'||e.key==='ArrowUp'){
      e.preventDefault();
      items.forEach(function(i){i.classList.remove('is-sel')});
      sel=e.key==='ArrowDown'?(sel+1)%items.length:(sel-1+items.length)%items.length;
      items[sel].classList.add('is-sel');
      items[sel].scrollIntoView?items[sel].scrollIntoView({block:'nearest'}):0;
    }
    if(e.key==='Enter'&&sel>-1){
      e.preventDefault();
      var a=items[sel].querySelector('a');if(a)window.location.href=a.getAttribute('href');
    }
  }

  function init(){
    document.querySelectorAll('a[href*="/search"]').forEach(function(a){
      if(a.closest('.rx-search'))return;
      if(a.dataset.rxS)return;a.dataset.rxS='1';
      a.addEventListener('click',open);
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape')close();
      if((e.ctrlKey||e.metaKey)&&e.key==='k'){e.preventDefault();open()}
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();